"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelAccountSchema = void 0;
exports.parsePanelAccount = parsePanelAccount;
const zod_1 = require("zod");
exports.PanelAccountSchema = zod_1.z.object({
  id: zod_1.z.string(),
  slug: zod_1.z.string(),
  first_name: zod_1.z.string(),
  last_name: zod_1.z.string(),
  userpic_id: zod_1.z.string().optional(),
  userpic: zod_1.z.any().optional(),
  cover_id: zod_1.z.string().optional(),
  cover: zod_1.z.any().optional(),
  country_id: zod_1.z.string().optional(),
  country: zod_1.z.any().optional(),
  spoken_languages: zod_1.z.array(zod_1.z.any()).optional(),
  subject_preferences: zod_1.z.array(zod_1.z.any()).optional(),
  teacher_status: zod_1.z.number().optional(),
  teacher_review_at: zod_1.z.string().optional(),
  last_active_at: zod_1.z.string().optional(),
  last_logged_in_at: zod_1.z.string().optional(),
  stats: zod_1.z.any().optional(),
  visit_info: zod_1.z.any().optional(),
  teacher_profile_verified: zod_1.z.boolean().optional(),
  status: zod_1.z.number().optional(),
  is_guest: zod_1.z.boolean().optional(),
  segments: zod_1.z.array(zod_1.z.any()).optional(),
  achievements: zod_1.z.array(zod_1.z.any()).optional(),
  trackers: zod_1.z.array(zod_1.z.any()).optional(),
  roles: zod_1.z.array(zod_1.z.number()).optional(),
  features: zod_1.z.array(zod_1.z.any()).optional(),
  hidden: zod_1.z.boolean().optional(),
  readonly: zod_1.z.boolean().optional(),
  mobile_phone: zod_1.z.string().optional(),
  purl: zod_1.z.string().optional(),
  logging: zod_1.z.boolean().optional(),
  __opts: zod_1.z.any().optional()
});
function parsePanelAccount(values) {
  return exports.PanelAccountSchema.parse(values);
}
